import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { WriteOnlyInput } from "components/Form/components/WriteOnlyInput/WriteOnlyInput";

export const WriteOnlyInputFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <WriteOnlyInput
                identifier={input.name}
                touched={meta.touched ?? false}
                errorMessage={meta.error}
                hasValue={fieldProps.hasValue ?? false}
                isMultiline={fieldProps.isMultiLine ?? false}
                isFormSubmitted={(meta.submitSucceeded || meta.submitting) ?? false}
                input={input}
                value={input.value}
            />
        </Input>
    );
};
